import { render, staticRenderFns } from "./verifiedRecords.vue?vue&type=template&id=6c9c3ff8&scoped=true&"
import script from "./verifiedRecords.vue?vue&type=script&lang=js&"
export * from "./verifiedRecords.vue?vue&type=script&lang=js&"
import style0 from "./verifiedRecords.vue?vue&type=style&index=0&id=6c9c3ff8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9c3ff8",
  null
  
)

export default component.exports